export const SHOW_CONFIRMATION_ALERT = 'SHOW_CONFIRMATION_ALERT';

export const HIDE_CONFIRMATION_ALERT = 'HIDE_CONFIRMATION_ALERT';
